"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMarkAllReadResponseDto = instanceOfMarkAllReadResponseDto;
exports.MarkAllReadResponseDtoFromJSON = MarkAllReadResponseDtoFromJSON;
exports.MarkAllReadResponseDtoFromJSONTyped = MarkAllReadResponseDtoFromJSONTyped;
exports.MarkAllReadResponseDtoToJSON = MarkAllReadResponseDtoToJSON;
exports.MarkAllReadResponseDtoToJSONTyped = MarkAllReadResponseDtoToJSONTyped;
/**
 * Check if a given object implements the MarkAllReadResponseDto interface.
 */
function instanceOfMarkAllReadResponseDto(value) {
    if (!('markedCount' in value) || value['markedCount'] === undefined)
        return false;
    return true;
}
function MarkAllReadResponseDtoFromJSON(json) {
    return MarkAllReadResponseDtoFromJSONTyped(json, false);
}
function MarkAllReadResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'markedCount': json['markedCount'],
    };
}
function MarkAllReadResponseDtoToJSON(json) {
    return MarkAllReadResponseDtoToJSONTyped(json, false);
}
function MarkAllReadResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'markedCount': value['markedCount'],
    };
}
